import Button from '../../MfaMethodSelector/styledComponents/Button';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Button, 'mfaSetup', ['button']);